module.exports = __webpack_public_path__ + "img/marker-icon-drone-error.23e631e8.png";